import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

const PatientInfoModal = ({ showPatientInfoUpdateConfirmModal, handleClose, setPatientInfoUpdateReason, updatePatientInfo }) => {
  return (
    <Modal show={showPatientInfoUpdateConfirmModal} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Header>
        <Modal.Title>Confirm changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure want to update the patient info?</p>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Reason for update?</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="e.g: customer entered wrong info during booking."
            onChange={e => setPatientInfoUpdateReason(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={updatePatientInfo}>
          yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PatientInfoModal;
